<template>
  <div id="product">
    <!--banner-->
    <div class="swiper-container swiper-no-swiping common" id="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide swiper-slide-banner">
          <div class="swiper-slide-title">
            <div style="padding-left: 20px;">
              <el-input class="autocomplete" popper-class="my-autocomplete" v-model="searchProduct" placeholder="搜索产品">
                <i class="icon-search" slot="suffix" @click="handleSearch">
                  <img src="https://img.deepbaytech.com/images2021/icon_search.png">
                </i>
              </el-input>
            </div>
            <div style="font-size: 14px; padding-left: 20px; margin-top: 12px;color: #999999;line-height: 20px;">
              <span style="margin-right: 20px;">软件平台</span><span style="margin-right: 20px;">DGX-A100</span><span style="margin-right: 20px;">NVIDIA
                专业显卡</span><span style="margin-right: 20px;">深度学习GPU</span><span style="margin-right: 20px;">InfiniBand</span><span>DDN存储</span>
            </div>
          </div>
          <img class="right" src="https://img.deepbaytech.com/images2021/product_banner-small.png">
        </div>
      </div>
    </div>
    <!--tab-bar-->
    <div id="tab-bar" class="common">
      <ul class="tab-bom">
        <li @click="routerFuc('/home')" :class="{on:$route.path.includes('/home')}">软件平台</li>
        <li @click="routerFuc('/solution')" :class="{on:$route.path.includes('/solution')}">DGX-A100
        </li>
        <li @click="routerFuc('/news')" :class="{on:$route.path.includes('/news')}">NVIDIA 专业显卡</li>
        <li @click="routerFuc('/product')" :class="{on:$route.path.includes('/product')}">深度学习GPU
        </li>
        <li @click="routerFuc('/cooperation')" :class="{on:$route.path.includes('/cooperation')}">
          InfiniBand</li>
        <li @click="routerFuc('/about')" :class="{on:$route.path.includes('/about')}">DDN存储</li>
      </ul>
    </div>
    <!--产品-->
    <div class="solution-main-content">
      <div class="solution-main-content-d">
        <div class="solution-main-content-d-title">
          <span class="solution-main-content-d-title-quan"></span>
          <span class="solution-main-content-d-title-text">智慧校园</span>
        </div>
        <ul class="solution-main-content-d-ul">
          <li class="solution-main-content-d-ul-li" @mouseenter="show=false" @mouseleave="show=true">
            <img v-show="show" src="https://img.deepbaytech.com/fn/af1-1.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">校门、宿舍进出识别</p>
              <p class="solution-main-content-d-ul-li-text">
                通过动态人脸识别技术实现对学生进出实现信息电子化、自动化记录，形成登记信息要素。方案利用成熟……</p>
            </div>
          </li>
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af1-22.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">考场异常行为</p>
              <p class="solution-main-content-d-ul-li-text">
                考场使用AI人脸特征和行为识别摄像，监督考场纪律，对于缺考情况精准掌握，对扭头等行为实时监控。
              </p>
            </div>
          </li>
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af1-3.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">校内异常行为</p>
              <p class="solution-main-content-d-ul-li-text">
                通过视频流接入，提供针对人群的实时分析服务。支持人数统计、人员密度统计、安全级别统计、事件类型统计等功能；能自定义异常情况的标准，并在异常情况发生时进行报警提醒，帮助管理人员进行决策制定。
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 第二个 -->
      <div class="solution-main-content-d">
        <div class="solution-main-content-d-title">
          <span class="solution-main-content-d-title-quan"></span>
          <span class="solution-main-content-d-title-text">智慧工地</span>
        </div>
        <ul class="solution-main-content-d-ul">
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af2-1.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">安全帽检测</p>
              <p class="solution-main-content-d-ul-li-text">
                对施工人员不按安全规范穿戴安全服或安全帽的行为进行识别并迅速告警，提高安全监管效率</p>
            </div>
          </li>
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af2-2.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">人证对比</p>
              <p class="solution-main-content-d-ul-li-text">
                人证对比技术可将有合法上岗证件的员工进行人脸入库，在工地现场将员工人脸与持证人员库进行比对，杜绝无证上岗，降低安全隐患。</p>
            </div>
          </li>
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af2-3.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">禁非区防控</p>
              <p class="solution-main-content-d-ul-li-text">
                对于非工作人员禁止入内区（禁非区）进行全面实时监控，任何非工作人员一经进入区域马上告警</p>
            </div>
          </li>
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af2-4.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">明火识别</p>
              <p class="solution-main-content-d-ul-li-text">
                对摄像头画面进行火焰识别分析，迅速高效，可有效弥补传统烟感报警装置在通风区域的缺陷。</p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 第三个 -->
      <div class="solution-main-content-d">
        <div class="solution-main-content-d-title">
          <span class="solution-main-content-d-title-quan"></span>
          <span class="solution-main-content-d-title-text">智慧园区</span>
        </div>
        <ul class="solution-main-content-d-ul">
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af3-1.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">人员考勤管理</p>
              <p class="solution-main-content-d-ul-li-text">
                基于人脸识别技术，用以区分园区在住人员和外来人员的管理考勤，事前检测预防、事后追查</p>
            </div>
          </li>
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af3-2.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">访客黑名单</p>
              <p class="solution-main-content-d-ul-li-text">通过分析摄像头画面，进行人像快速对比，识别访客或者黑名单人员</p>
            </div>
          </li>
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af3-3.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">会议签到</p>
              <p class="solution-main-content-d-ul-li-text">现场刷脸签到提升管理效率</p>
            </div>
          </li>
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af3-4.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">车辆管理</p>
              <p class="solution-main-content-d-ul-li-text">
                基于车辆、车牌识别技术，有效解决园区有限车位的管理问题，同时对外来车辆进行监控存档</p>
            </div>
          </li>
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af3-5.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">关键区域监控</p>
              <p class="solution-main-content-d-ul-li-text">针对特定时段、私密性区域进行监控，对违规进入人员进行记录和预警</p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 第四个 -->
      <div class="solution-main-content-d">
        <div class="solution-main-content-d-title">
          <span class="solution-main-content-d-title-quan"></span>
          <span class="solution-main-content-d-title-text">智慧警务</span>
        </div>
        <ul class="solution-main-content-d-ul">
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af4-1.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">车辆侦查</p>
              <p class="solution-main-content-d-ul-li-text">
                分析视频中的车辆特征信息，包括车牌、车身、内饰、标志物、驾驶员人脸等，以车辆图像特征做以图搜图，对假套牌车、同行车、频繁过车等行为进行智能分析，应用于刑事侦查、稽查布控、重大安保及信息情报等领域
              </p>
            </div>
          </li>
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af4-2.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">人脸侦查</p>
              <p class="solution-main-content-d-ul-li-text">对监控视频中可疑人员进行人脸识别，进行嫌犯追逃、重点人员防控等</p>
            </div>
          </li>
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af4-3.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">重点道路监控</p>
              <p class="solution-main-content-d-ul-li-text">
                基于人脸识别与大数据计算技术，从公安实战业务出发，集实时监控重点道路及路口人流，利用AI+大数据技术，为交通、图侦、治安、情报等业务警种提供有力的技术支持。</p>
            </div>
          </li>
          <li class="solution-main-content-d-ul-li">
            <img src="https://img.deepbaytech.com/fn/af4-4.png" alt="">
            <div class="solution-main-content-d-ul-li-all">
              <p class="solution-main-content-d-ul-li-title">重点场合监控</p>
              <p class="solution-main-content-d-ul-li-text">
                提供人像布控，系统设定黑名单管理机制，一旦黑名单中的人员进入监控范围，系统自动发出预警，提醒安保人员。提供复杂场景的快速准确识别，解决人流量大的场景下低头、侧脸、逆光、遮挡等问题
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--服务咨询-->
    <Consultation class="common" />
    <!-- 尾部 -->
    <Footer class="common" />
  </div>
</template>

<script>
import Consultation from "./../../components/Consultation/Consultation"
import Footer from "./../../components/Footer/Footer"
export default {
  name: "product",
  components: {
    Consultation,
    Footer
  },
  data () {
    return {
      show: true,
      searchProduct: ''
    }
  },
}
</script>

<style scoped>
.common {
  min-width: 1180px;
}
.swiper-container {
  height: 200px;
  background-color: #f6faf3;
}
.swiper-slide-banner {
  width: 100%;
  height: 200px !important;
}
.swiper-slide {
  position: relative;
  background-size: cover;
  width: 1180px;
  margin: auto;
  display: flex;
  justify-self: center;
  align-items: center;
}
.swiper-slide-title {
  color: #333;
  width: 1180px;
  margin: 0 auto;
  padding-top: 0px;
}
::v-deep .el-input__inner {
  width: 560px;
  height: 48px;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.08);
  border-radius: 0%;
}
.right {
  width: 504px;
  height: 200px;
}
.autocomplete {
  position: relative;
}
.icon-search {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-280%, -50%);
  display: inline-block;
  width: 32px;
  height: 32px;
}
#tab-bar {
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  color: #000000;
  z-index: 999;
  font-size: 14px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
}
#tab-bar:hover {
  background-color: rgba(255, 255, 255, 1);
}
.tab-bom {
  width: 1180px;
  margin: auto;
  height: 64px;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tab-bom > li {
  list-style: none;
  cursor: pointer;
}
.tab-bom > li:hover {
  color: #77ba00;
}
.on {
  color: #77ba00;
}
.solution-main-content {
  margin-top: 54px !important;
  width: 1180px;
  margin: auto;
}
.solution-main-content-d {
  width: 100%;
  max-width: 1180px;
}
.solution-main-content-d-title-text {
  font-size: 24px;
  color: #333333;
}
.solution-main-content-d-ul {
  padding-bottom: 48px;
  display: flex;
  flex-wrap: wrap;
}
.solution-main-content-d-ul-li {
  width: 280px;
  height: 294px;
  background: #ffffff;
  margin-top: 20px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  margin-right: 15px;
  overflow: hidden;
}
.solution-main-content-d-ul-li:hover {
  cursor: pointer;
  background-color: #77ba00;
}
.solution-main-content-d-ul-li:hover p {
  color: #fff !important;
}
.solution-main-content-d-ul-li img {
  width: 280px;
  height: 168px;
  transition: all 0.5s;
}
.solution-main-content-d-ul-li img:hover {
  transform: scale(1.2, 1.2);
}
.solution-main-content-d-ul-li-all {
  padding: 16px;
}
.solution-main-content-d-ul-li-title {
  font-size: 16px;
  color: #333333;
  font-weight: 500;
}
.solution-main-content-d-ul-li-text {
  font-size: 14px;
  color: #666666;
  margin-top: 12px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
</style>
